import LazyLoad from 'vanilla-lazyload';

export function initLazyLoading(APP) {
  let init = () => {
    APP.lazyLoadInstance = new LazyLoad({
      threshold: 600,
      elements_selector: '[data-src], [data-bg], .lazy',
      class_entered: 'lazy-entered',
    });
    APP.lazyLoadInstance.update();
  };

  init();
}
